/**
 * isForgetPassword : 是否显示忘记密码
 * isResetPassword: 是否显示重置密码
 */
const login = {
  state: {
    isForgetPassword: false,
    isResetPassword: false,
  },
  mutations: {
    switchLogin(state, type) {
      // eslint-disable-next-line no-unused-expressions
      type === '1' ? state.isForgetPassword = true : state.isForgetPassword = false;
    },
    resetStatus(state, type) {
      // eslint-disable-next-line no-unused-expressions
      type === '1' ? state.isResetPassword = true : state.isResetPassword = false;
    },
  },
};

export default login;
